let URL;
// let appMode = process.env.REACT_APP_ENV;
// let appMode = "development"; 
let appMode = "production";

let ASSET_URL = "http://103.189.173.7:3369/api";

if (appMode === "production") {
  // URL = "http://localhost:5022/api";
  URL = "https://api.project.kitchen/api";
  // URL = "http://103.189.173.7:5022/api";
} else {
  URL = "http://103.189.173.7:5022/api";
  // URL = "http://localhost:5022/api";
}

// 153.92.4.13:6555

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,
  dashboard: "vendor/dashboard",

  // Auth API
  logout: "admin/auth/logout",

  login: "admin/auth/login",
  adminLogin: "auth/admin/login",
  adminLoginVerifyOtp: "auth/admin/login/verify-otp",
  authProfile: "auth/profile",
  authUpdateProfile: "auth/profile",
  authDashboardStats: "auth/admin/dashboard-stats",
  authChangePassword: "auth/change-password",
  authUpdateProfileImage: "auth/profile-image",
  authDeleteProfileImage: "auth/profile-image",
  authRequestEmailChangeOtp: "auth/profile/change-email/request-otp",
  authVerifyEmailChangeOtp: "auth/profile/change-email/verify-otp",
  authAdminUsersList: "auth/admin/users",
  authAdminUserById: "auth/admin/users",
  authAdminUserStatusUpdate: "auth/admin/users",
  authAdminUserPermanentDelete: "auth/admin/users/permanent-delete",
  profile: "get-profile",
  updateProfile: "admin/auth/update-profile",
  changePassword: "auth/change-password",
  updateAppSetting: "admin/auth/update-app-setting",
  forgotPassword: "admin/auth/forgot-password",
  verifyOTP: "admin/auth/verify-otp",
  resetPassword: "admin/auth/reset-password",
  authForgotPassword: "auth/forgot-password",
  authVerifyOtp: "auth/verify-otp",
  authResetPassword: "auth/reset-password",

  // Admin custom ingredients
  authAdminCustomIngredientsList: "auth/admin/custom-ingredients",
  authAdminCustomIngredientById: "auth/admin/custom-ingredients",
  authAdminCustomIngredientUpdate: "auth/admin/custom-ingredients",
  authAdminCustomIngredientDelete: "auth/admin/custom-ingredients",
  authAdminIngredientCategoriesList: "auth/admin/ingredient-categories",
  authAdminIngredientCategoriesSuggestions: "auth/admin/ingredient-categories/suggestions",
  authAdminWaitlistList: "auth/admin/waitlist",
  authAdminWaitlistApprove: "auth/admin/waitlist",
  authAdminWaitlistInvite: "auth/admin/waitlist",
  authAdminDiscountCodes: "auth/admin/discount-codes",
  authAdminCustomIngredientCreate: "auth/admin/custom-ingredients",

  // Admin content manager
  authAdminContentPages: "auth/admin/content-pages",
  authAdminEmailTemplates: "auth/admin/email-templates",

  // Admin billing
  adminBillingLogs: "auth/admin/billing/logs",
  adminBillingStats: "auth/admin/billing/stats",
  adminPlans: "auth/admin/plans",
  adminTrials: "auth/admin/trials",
  adminAuditLogs: "auth/admin/audit-logs",


  common: {
    userOrVendors: "common/user-or-vendor",
    vendors: "common/vendor",
  },
};

export default apiPath;
